module.exports = __webpack_public_path__ + "static/media/heart-icon-white.d8907f56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heart-icon-white.svg
// module id = 1076
// module chunks = 0